import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AppOAuthStorageService implements Storage {
  private readonly storageKey = '__y42_oauth__';

  get length() {
    return Object.keys(this.getOAuthData()).length;
  }

  clear() {
    this.getStorage().setItem(this.storageKey, JSON.stringify({}));
  }

  getItem(key: string): string | null {
    const keyValue = this.getOAuthData()[key];
    return keyValue ? keyValue : null;
  }

  key(index: number): string | null {
    const keys = Object.keys(this.getOAuthData());
    return keys[index] || null;
  }

  removeItem(key: string) {
    const data = { ...this.getOAuthData() };
    delete data[key];
    this.getStorage().setItem(this.storageKey, JSON.stringify(data));
  }

  setItem(key: string, value: string) {
    const data = { ...this.getOAuthData() };
    data[key] = value;
    this.getStorage().setItem(this.storageKey, JSON.stringify(data));
  }

  get data() {
    return { ...this.getOAuthData() };
  }

  private getOAuthData() {
    const data = this.getStorage().getItem(this.storageKey);
    return data ? JSON.parse(data) : {};
  }

  private getStorage(): Storage {
    return localStorage;
  }
}
